export default __webpack_public_path__ + "static/balticon-989350209b61305d49767bb79841b6af.svg";